import {
  Box,
  Paper,
  Typography,
  Chip
} from "@mui/material";
import {
  Assessment as StatusIcon,
  CheckCircle as ActiveIcon,
  Block as InactiveIcon,
  FitnessCenter as TrainersIcon,
  Groups as ClientsIcon
} from "@mui/icons-material";

const CompanyStatusSection = ({company, statistics}) => {
  const getStatusColor = (enabled) => ({
    backgroundColor: enabled ? '#E8F5E8' : '#FFF2F2',
    color: enabled ? '#2E7D32' : '#D32F2F'
  });

  return (
      <Paper
          sx={{
            backgroundColor: "#FCFCFD",
            border: "1px solid #E2E8F0",
            borderRadius: "8px",
            direction: "rtl"
          }}
          elevation={0}
      >
        {/* Header */}
        <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: { xs: "12px 16px", md: "16px 20px" },
              backgroundColor: "#F8FAFC",
              borderBottom: "1px solid #E2E8F0"
            }}
        >
          <Box sx={{display: "flex", alignItems: "center", gap: 1}}>
            <StatusIcon sx={{ color: "#64748B", fontSize: { xs: "18px", md: "20px" } }} />
            <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: { xs: "14px", md: "16px" },
                  color: "#1E293B",
                  fontFamily: '"Heebo", "Roboto", sans-serif'
                }}
            >
              סטטוס חברה
            </Typography>
          </Box>

          <Chip
              label={company.enabled ? "פעילה" : "חסומה"}
              icon={company.enabled ? <ActiveIcon /> : <InactiveIcon />}
              size="small"
              sx={{
                ...getStatusColor(company.enabled),
                fontWeight: 600,
                fontSize: { xs: "10px", md: "11px" },
                height: { xs: "22px", md: "24px" }
              }}
          />
        </Box>

        {/* Content */}
        <Box sx={{padding: { xs: "16px", md: "20px" }}}>
          <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "1fr",
                  sm: "repeat(2, 1fr)",
                  md: "repeat(3, 1fr)",
                  lg: "repeat(4, 1fr)"
                },
                gap: "16px 24px",
                rowGap: "12px"
              }}
          >
            {/* Statistics */}
            <StatusRow
                icon={<TrainersIcon />}
                label="מספר מאמנים"
                value={statistics.numberOfTrainers || "0"}
            />

            <StatusRow
                icon={<ClientsIcon />}
                label="מספר לקוחות"
                value={statistics.numberOfTrainees || "0"}
            />
          </Box>
        </Box>
      </Paper>
  );
};

const StatusRow = ({icon, label, value}) => (
    <Box sx={{display: "flex", alignItems: "flex-start", gap: 1.5, minHeight: "24px"}}>
      <Box
          sx={{
            color: "#64748B",
            display: "flex",
            alignItems: "center",
            fontSize: "14px",
            flexShrink: 0,
            marginTop: "1px"
          }}
      >
        {icon}
      </Box>
      <Box sx={{flex: 1, minWidth: 0}}>
        <Typography
            sx={{
              fontSize: "13px",
              fontWeight: 500,
              color: "#64748B",
              marginBottom: "2px",
              textAlign: "right"
            }}
        >
          {label}:
        </Typography>
        <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 600,
              color: "#1E293B",
              lineHeight: "18px",
              textAlign: "right"
            }}
        >
          {value}
        </Typography>
      </Box>
    </Box>
);

export default CompanyStatusSection;